'use client';

import styled from 'styled-components';

import { colors } from '@/styles/theme';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 300px;
  height: 370px;

  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  overflow: hidden;

  /* Premium layered shadow system for authentic depth */
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.05),
    0 16px 32px rgba(0, 0, 0, 0.04);

  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    cursor: pointer;
    transform: translateY(-4px);
    box-shadow:
      0 2px 4px rgba(0, 0, 0, 0.05),
      0 8px 24px rgba(0, 0, 0, 0.08),
      0 24px 48px rgba(0, 0, 0, 0.06);
    border-color: rgba(0, 0, 0, 0.08);
  }
`;

export const ImageWrap = styled.div`
  position: relative;
  height: 215px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
  padding: 12px 8px;

  background-color: ${colors.light};
`;

export const Title = styled.h3`
  margin-bottom: 8px;

  font-size: 1.2rem;
  font-weight: 600;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;

  gap: 10px;

  font-size: 0.9rem;
  color: ${colors.lagoon};
`;

export const Author = styled.div`
  color: ${colors.lagoon};
`;

export const Published = styled.div``;
